import bfbAuthBackground from 'static/images/Auth-Layout-Background.jpg';
import B4Blogo from 'static/images/B4Blogo.svg';

const getCustomizationProps = (customization = {}, isLoading = false) => {
  if (isLoading) {
    return {
      bottomImg: null,
      bottomLayout: 0,
      logoImg: null,
      logoLayout: 0,
    };
  }
  // if there is customization, return the customization otherwise return default Bridge values

  return {
    bottomImg: customization.bottomLogo || null,
    bottomLayout: customization.bottom_logo_layout,
    customizationId: customization?.id,
    logoImg: customization.platformMainLogo || B4Blogo,
    logoLayout: customization.main_logo_layout ?? 0,
    memberPhoneNumberRequiredOnSignup: customization.member_phone_number_required_on_signup,
    mentorPhoneNumberRequiredOnSignup: customization.mentor_phone_number_required_on_signup,
    programName: customization.program_name,
  };
};

const getLayoutStyle = (customization, isLoading) => {
  if (isLoading) return { backgroundImage: null };

  return customization.backgroundLogo
    ? {
        backgroundImage: `url('${customization.backgroundLogo}')`,
        backgroundColor: 'rgb(0, 0, 0, 0.2)',
        backgroundBlendMode: 'color',
      }
    : {
        backgroundImage: `url('${bfbAuthBackground}')`,
      };
};

export { getCustomizationProps, getLayoutStyle };
